import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

/**
 * @param {Object} props
 * @param {string} props.link
 * @param {string} props.text
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.styles]
 * @param {boolean} [props.hideIcon]
 * @param {"solid" | "outline"} [props.appearance]
 * @param {boolean} [props.newTab]
 */
const AuraButtonGreen = ({
    link,
    text,
    className = "",
    styles = {},
    hideIcon = false,
    appearance = "solid",
    newTab = false,
    disabled,
}) => {
    const baseClass = appearance === "outline" ? "aura-green-button-outlined" : "aura-green-button";

    return (
        <Link
            to={link}
            className={`${baseClass} ${className}`}
            style={styles}
            target={newTab ? "_blank" : "_self"}
            rel={newTab ? "noopener noreferrer" : undefined}
            disabled={disabled}
        >
            <p className="mb-0">{text}</p>
            {!hideIcon && (
                <i
                    className={`fa-solid ${document.dir === "rtl"
                        ? "fa-arrow-left-long"
                        : "fa-arrow-right-long"
                        }`}
                    aria-hidden="true"
                ></i>
            )}
        </Link>
    );
};

export default AuraButtonGreen;